import * as types from '../const/action.types';
import { get, put, post, del } from '../api/_basic';

function getFilter(filter) {
    const { saved, pending, urgent, from, to, selectedusers } = filter;

    return (
        `?filtro=true` +
        (pending ? '&sinleer=true' : '') +
        (saved ? '&cerrados=true' : '') +
        (urgent ? '&prioridad=true' : '') +
        (from ? `&fechaIni=${from}` : '') +
        (to ? `&fechaFin=${to}` : '') +
        (selectedusers ? `&idEnviadapor=${selectedusers}` : '')
    );
}

export function loadMessages(runfilter, filter) {
    return async (dispatch) => {
        dispatch(messagesHasErrored(false, ''));
        dispatch(messagesIsLoading(true));
        const text_filter = runfilter ? getFilter(filter) : '';
        return get(`${process.env.REACT_APP_API_MESSAGES}${text_filter}`)
            .then((response) => {
                dispatch(messagesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(messagesHasErrored(false, ''));
                dispatch(loadMessagesSuccess(items));
            })
            .catch((error) => {
                dispatch(messagesIsLoading(false));
                dispatch(messagesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addMessage(message) {
    return async (dispatch) => {
        dispatch(messagesIsLoading(true));
        return post(`${process.env.REACT_APP_API_MESSAGES}`, message)
            .then((response) => {
                dispatch(messagesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function answerMessage(message) {
    return async (dispatch) => {
        dispatch(messagesIsLoading(true));
        return put(`${process.env.REACT_APP_API_MESSAGES}/${message.id}/responder`, message)
            .then((response) => {
                dispatch(messagesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                dispatch(messagesIsLoading(false));
                console.log(error);
                throw error;
            });
    };
}

export function deleteMessage(message) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_MESSAGES}/${message}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function deleteMessageAttached(message, attached) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_MESSAGES}/${message}/adjunto/${attached}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function sendCommunicationMessage(communication) {
    return async (dispatch) => {
        dispatch(messagesIsLoading(true));
        return post(
            `${process.env.REACT_APP_API_MESSAGES}/${communication.id}/comentario`,
            communication,
        )
            .then((response) => {
                dispatch(messagesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .catch((error) => {
                dispatch(messagesIsLoading(false));
                console.log(error);
                throw error;
            });
    };
}

export function saveMessage(message) {
    return async (dispatch) => {
        dispatch(messagesIsLoading(true));
        return put(`${process.env.REACT_APP_API_MESSAGES}/${message.id}/cerrar`, message)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                dispatch(messagesIsLoading(false));
                return true;
            })
            .catch((error) => {
                dispatch(messagesIsLoading(false));
                console.log(error);
                throw error;
            });
    };
}

export function loadInfoMessage(message) {
    return async function(dispatch) {
        dispatch(messagesHasErrored(false, ''));
        dispatch(messagesIsLoading(true));
        return get(`${process.env.REACT_APP_API_MESSAGES}/${message}`)
            .then((response) => {
                dispatch(messagesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(messagesHasErrored(false, ''));
                dispatch(loadMessageSuccess(item));
            })
            .catch((error) => {
                dispatch(messagesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function marcarMessageReaded(data) {
    return {
        type: types.MESSAGE_MARK_AS_READED,
        data,
    };
}

export function loadMessageSuccess(data) {
    return {
        type: types.LOAD_MESSAGE_SUCCESS,
        data,
    };
}

export function loadMessagesSuccess(data) {
    return {
        type: types.MESSAGES_SUCCESS,
        data,
    };
}

export function messagesHasErrored(bool, message) {
    return {
        type: types.MESSAGES_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function messagesIsLoading(bool) {
    return {
        type: types.MESSAGES_IS_LOADING,
        isLoading: bool,
    };
}

export function messageIsSaving(bool) {
    return {
        type: types.MESSAGES_IS_SAVING,
        isLoading: bool,
    };
}

export function crearMensaje(data) {
    return {
        type: types.MESSAGES_EVT_COM_ADD,
        data,
    };
}

export function addcomment(data) {
    return {
        type: types.MESSAGES_EVT_CMNT_ADD,
        data,
    };
}



// WEBPACK FOOTER //
// ./src/actions/messages.actions.js